export enum MetaPages {
  ABOUT_FOCUS = 'About Focus Global',
  ABOUT_HERITAGE = 'Brand Heritage',
  ABOUT_SZWF = 'About Sub-Zero and Wolf',
  ABOUT_QUOTATION = 'Request for Quotation',
  ABOUT_SUSTAINABILITY = 'Sustainability',
  ABOUT_SHOWROOM = 'Showroom Locations',
  CONTACT = 'Contact Us',
  CUSTOMER_SERVICE = 'Customer Service',
  FRIENDS_OF_THE_KITCHEN = 'Friends of the Kitchen',
  KITCHEN_GALLERY = 'Kitchen Gallery',
  MANUALS_AND_GUIDES = 'Manuals and Guides',
  NEWS_AND_EVENTS = 'News and Events',
  PRIVACY_POLICY = 'Privacy Policy',
  RECIPES = 'Recipes',
  SITE_SEARCH = 'Site Search',
  TRADE_RESOURCES = 'Trade Resources',
  USE_AND_CARE_VIDEOS = 'Use and Care Videos',
  VIDEO_GALLERY = 'Video Gallery'
}
